<template>
  <div>
    <!-- A. 탭(다건) -->
    <div v-if="this.termByWeekList.length > 1">
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="tabItem in termByWeekList" :key="tabItem.weekNm"
          >{{ tabItem.weekNm }} {{ $t('주차') }}</v-tab
        >
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in termByWeekList" :key="tabItem.weekNm">
          <v-row class="title-wrap">
            <v-col
              cols="12"
              class="detail-title week d-flex justify-space-between"
              >{{ tabItem.weekNm }}{{ $t('주차') }}
            </v-col>
          </v-row>

          <work-time-sta-list
            v-bind:searchTermParam="tabItem"
          ></work-time-sta-list>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- B. 단건 -->
    <div v-else>
      <v-row class="title-wrap">
        <v-col cols="12" class="detail-title d-flex justify-space-between">
          {{ $t('이번주 근무현황') }}
        </v-col>
      </v-row>

      <work-time-sta-list
        v-bind:searchTermParam="this.termByWeekList[0]"
      ></work-time-sta-list>
    </div>
  </div>
</template>

<script>
/* 근무현황 상세 컴포넌트 */
import WorkTimeStaList from '@/components/status/WorkTimeStaList.vue';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export default {
  props: {
    // 조회조건파라미터
    searchParam: {
      type: Object,
    },
  },

  data: () => ({
    tab: null,
    termByWeekList: [], // 주별기간리스트
  }),

  watch: {
    searchParam() {
      this.makeTermByWeekList();
    },

    termByWeekList() {
      if (this.termByWeekList.length > 1) {
        this.tab = 0; // 첫번째 탭 자동선택
      }
    },
  },

  methods: {
    /* 근무주기에 따른 주별기간리스트 생성 */
    makeTermByWeekList() {
      const paramSdate = this.searchParam.searchTerm.sdate;
      const paramEdate = this.searchParam.searchTerm.edate;
      const workCycleCd = Number(this.searchParam.workCycleCd);

      // 1. 주별기간리스트 초기화
      // A형식 : [{sdate, edate}, {}, {}...]
      // B형식 : [{weekNm, sdate, edate}, {}, {}...]
      this.termByWeekList = [];

      // 2. 주별기간리스트 값세팅
      // 2-a. 근무주기 = '1주'인 경우
      if (workCycleCd == 7) {
        this.termByWeekList.push({
          sdate: paramSdate,
          edate: paramEdate,
        });
      }
      // 2-b. 근무주기 = '2주'이상인 경우
      else {
        const sDayNo = dayjs(paramSdate).day(); // 시작요일번호 (월:1~토:6,일:0)
        const delayDayCnt = sDayNo == 1 ? 0 : sDayNo == 0 ? 6 : sDayNo - 1; // 1주차를 맞추기 위한 필요일수

        // 2-b-1. 1주차 시작일-종료일 셋팅
        let sdate = paramSdate;
        let edate = dayjs(sdate)
          .add(6 - delayDayCnt, 'day')
          .format('YYYYMMDD');
        //console.log(`# [MAKE_1] START! sdate = ${sdate}, edate = ${edate}`);

        // 2-b-2. 주별기간리스트에 주차별 시작일-종료일 추가셋팅
        let i = 0; // 주차 단위

        while (!dayjs(edate).isSameOrAfter(paramEdate)) {
          if (i >= 1) {
            // 2주차부터는 다시 계산
            sdate = dayjs(edate).add(1, 'day').format('YYYYMMDD');
            edate = dayjs(sdate).add(6, 'day').format('YYYYMMDD');

            // 마지막 주차의 종료일은 paramEdate로 세팅
            if (dayjs(edate).isAfter(paramEdate)) {
              edate = paramEdate;
            }
          }
          //console.log(`# [MAKE_2-${i}] sdate = ${sdate}, edate = ${edate}`);

          this.termByWeekList.push({
            weekNm: ++i,
            sdate,
            edate,
          });
        }
      }

      // console.log(
      //   '🔥 termByWeekList :: ' + JSON.stringify(this.termByWeekList),
      // );
    },
  },

  components: {
    WorkTimeStaList,
  },
};
</script>

<style>
.v-tabs .v-tabs-bar .v-slide-group__prev,
.v-tabs .v-tabs-bar .v-slide-group__next {
  display: none !important;
}
.v-tabs .v-tabs-bar .v-tab {
  padding: 0px 20px !important;
}
</style>
